// extracted by mini-css-extract-plugin
module.exports = {"root":"product-card-size_root__tBXJD","imageWrapper":"product-card-size_imageWrapper__ddiNG","info":"product-card-size_info__Q_jqp"};